// extracted by mini-css-extract-plugin
export default {"partners__container":"PartnersContainer_partners__container__Rhbo1"};